// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function SetyScripts() {
//   const { pathname } = useLocation();

// //   useEffect(() => {
// //     // 1. Force remove any "ghost" cursors before starting
// //     const oldCursor = document.querySelector('.cb-cursor');
// //     if (oldCursor) oldCursor.remove();

// //     const timer = setTimeout(() => {
// //         if (window.initSety) {
// //             window.initSety();
// //         }
// //     }, 300); // 300ms gives React plenty of time to stabilize the DOM

// //     return () => clearTimeout(timer);
// // }, [pathname]);


//   return null;
// }
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function SetyScripts() {
  const { pathname } = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    // 1. Scroll to top on page change
    window.scrollTo(0, 0);

    // 2. Run initSety only once on mount, then just refresh ScrollTrigger
    if (!initialized.current && window.initSety) {
      window.initSety();
      initialized.current = true;
    } else {
      // Just refresh ScrollTrigger on route changes
      if (window.ScrollTrigger) {
        setTimeout(() => {
          window.ScrollTrigger.refresh();
        }, 100);
      }
    }
  }, [pathname]);

  return null;
}